import { Component, OnInit } from '@angular/core';
import { BillingService } from '../services/billing.service';
import { BillingDetails } from '../models/billing-details';
import { AlertService } from '../../shared/services/alert.service';
import { DacConfig } from '../services/dac-config.service';

@Component({
  selector: 'dac-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss']
})
export class BillingDetailsComponent implements OnInit {

  private billingDetails:BillingDetails;
  public loading:boolean;

  constructor(private billingService:BillingService
  ,private alertService:AlertService
  ,private dacConfig:DacConfig) { 
    this.billingDetails = new BillingDetails();
  }

  get hasSubscription() {
    return this.billingDetails.subscriptions.length > 0;
  }

  ngOnInit() {
    this.loading = true;
    this.billingService.getBillingDetails()
    .then(details => {
      this.billingDetails = details
      this.loading = false;
    })
    .catch((error) => {
      this.loading = false;
      console.error(error);
      this.alertService.error("Failed to retrieve billing details from server.  Check your network connection and refresh the page.");
    });
  }

  get Billing() {
    return this.billingDetails;
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  public setupCard() {
    this.billingService.updateDefaultBillingCard(this.billingDetails)
    .then((updatedBillingDetails) => {
      this.billingDetails = updatedBillingDetails;
      this.alertService.success("Default billing card updated");
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("There was an error updating your default billing card.  Please try again or contact customer support");
    });
  }

  public removeCard() {
    if (confirm("Are you sure you want to delete this card?")) {
      this.billingService.deleteDefaultBillingCard(this.billingDetails)
      .then((billingDetails) => {
        this.billingDetails = billingDetails;
        this.alertService.success("Deleted billing card");
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/billing-details/billing-details.component.ts